// Prepares a pasted or picked screenshot for the base64 upload endpoint
// (POST /api/v1/feedback/:id/screenshot). The image is scaled down in the
// browser so the upload stays inside the backend body limit. PNG is preferred
// because screenshots are mostly text and stay crisp; a large paste is
// re-encoded as a high-quality JPEG.
const MAX_DIMENSION = 1800;
const PNG_BUDGET_BYTES = 1200000;
const JPEG_QUALITY = 0.9;

export const MAX_SCREENSHOTS = 5;

const base64Bytes = base64 => {
  const padding = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0;
  return Math.floor((base64.length * 3) / 4) - padding;
};

export const prepareScreenshot = file =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
        const width = Math.max(1, Math.round(img.width * scale));
        const height = Math.max(1, Math.round(img.height * scale));

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Canvas context nicht verfuegbar');
        ctx.drawImage(img, 0, 0, width, height);

        let contentType = 'image/png';
        let dataUrl = canvas.toDataURL('image/png');
        let dataBase64 = (dataUrl.split(',')[1] || '');
        if (base64Bytes(dataBase64) > PNG_BUDGET_BYTES) {
          contentType = 'image/jpeg';
          dataUrl = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
          dataBase64 = dataUrl.split(',')[1] || '';
        }

        URL.revokeObjectURL(objectUrl);
        const base = (file.name || 'screenshot').replace(/\.[^.]+$/, '') || 'screenshot';
        resolve({
          fileName: `${base}.${contentType === 'image/png' ? 'png' : 'jpg'}`,
          contentType,
          dataBase64,
          previewUrl: dataUrl,
          size: base64Bytes(dataBase64),
        });
      } catch (err) {
        URL.revokeObjectURL(objectUrl);
        reject(err);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Bild konnte nicht gelesen werden'));
    };
    img.src = objectUrl;
  });

// Extracts the images of a paste event, or an empty array for a text paste.
export const imagesFromClipboard = event => {
  const items = Array.from(event?.clipboardData?.items || []);
  return items
    .filter(item => item.kind === 'file' && String(item.type).startsWith('image/'))
    .map(item => item.getAsFile())
    .filter(Boolean);
};
